import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { App } from '@df/core/app';
import { Status } from '@df/core/status';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { Subscription } from 'rxjs/internal/Subscription';
import { BasketDecorator } from '../../../customer/api/basket/basket.decorator';

@Component({
    selector: 'basket-oos-items-warning',
    templateUrl: './basket-oos-items-warning.html',
    standalone: true,
    imports: [CommonModule, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BasketOosItemsWarningComponent implements OnInit, OnDestroy {
    @Input()
    status = new Status();

    protected subscription = new Subscription();

    constructor(
        private cd: ChangeDetectorRef,
        private app: App
    ) { }


    get basket(): BasketDecorator {
        return <BasketDecorator>this.app.customer.basket;
    }

    ngOnInit(): void {
        this.subscription.add(this.status.subscribe(() => this.cd.detectChanges()));
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    removeOOSProducts(): void {
        this.basket.removeOOSProducts(this.status);
    }
}
